import swal from "sweetalert";
import {
  CREATE_COME_BACK_DOCTOR_FAIL,
  CREATE_COME_BACK_DOCTOR_REQUEST,
  CREATE_COME_BACK_DOCTOR_SUCCESS,
  FETCH_COME_BACK_DOCTOR_FAIL,
  FETCH_COME_BACK_DOCTOR_REQUEST,
  FETCH_COME_BACK_DOCTOR_SUCCESS,
  UPDATE_COME_BACK_DOCTOR_FAIL,
  UPDATE_COME_BACK_DOCTOR_REQUEST,
  UPDATE_COME_BACK_DOCTOR_SUCCESS,
} from "../../ActionType/AffiarsOfSurgeryTypes/ComeBackDoctorType";
import { api } from "../../Api/api";
import { getToken } from "../login";
import { getVisitAction } from "../VisitAction/VisitAction";

export const getComeBackDoctorAction =
  (page, perPage, fullname, code, gender, phone,birthDate, branch_id) =>
  async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        page,
        perPage,
        fullname,
        code,
        gender,
        phone,
        branch_id,
        birthDate
      },
    };

    dispatch({
      type: FETCH_COME_BACK_DOCTOR_REQUEST,
      payload: [],
    });
    try {
      const response = await api.get("comeBackDoctor", config);
      const { status, data } = response;

      if (status == 200) {
        dispatch({
          type: FETCH_COME_BACK_DOCTOR_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: FETCH_COME_BACK_DOCTOR_FAIL,
        payload: [],
      });
    }
  };
export const createComeBackDoctorAction =
  (note, visitId, branchId, patientId) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: CREATE_COME_BACK_DOCTOR_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "comeBackDoctor/create",
        { visit_id: visitId, branch_id: branchId, note },
        config
      );
      const { status, data } = response;

      if (status == 201) {
        dispatch(getVisitAction(patientId));
        dispatch(getVisitAction(patientId));
        swal({
          title: "Good job!",
          text: "Come back doctor  was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: CREATE_COME_BACK_DOCTOR_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: CREATE_COME_BACK_DOCTOR_FAIL,
        payload: [],
      });
    }
  };

export const updateComeBackDoctorAction =
  (id, note, visitId, branchId, patientId) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: UPDATE_COME_BACK_DOCTOR_REQUEST,
      payload: [],
    });
    try {
      const response = await api.put(
        `comeBackDoctor/update/${id}`,
        { visit_id: visitId, branch_id: branchId, note },
        config
      );
      const { status, data } = response;

      if (status == 200) {
        dispatch(getVisitAction(patientId));
        dispatch(getVisitAction(patientId));
        swal({
          title: "Good job!",
          text: "Come back doctor  was Updated Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: UPDATE_COME_BACK_DOCTOR_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: UPDATE_COME_BACK_DOCTOR_FAIL,
        payload: [],
      });
    }
  };
